<template>
  <div>
    <breadcrumb-bar :crumbs="crumbs"></breadcrumb-bar>

    <div class="portlet light">
      <div class="portlet-title tabbable-line">
        <div class="caption caption-md">
          <span class="caption-subject font-dark sbold uppercase">Support</span>
        </div>

        <ul class="nav nav-tabs">
          <li :class="{active: activeTab === 'Contact'}">
            <router-link :to="{name: 'Contact'}" aria-expanded="false">Contact</router-link>
          </li>
          <li :class="{active: activeTab === 'FAQ'}">
            <router-link :to="{name: 'FAQ'}" aria-expanded="false">Frequently asked questions</router-link>
          </li>
          <li :class="{active: activeTab === 'Help and Tutorials'}">
            <router-link :to="{name: 'Help and Tutorials'}" aria-expanded="false">Video tutorials</router-link>
          </li>
        </ul>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  export default {
    components: {
      'breadcrumb-bar': Breadcrumbs
    },
    computed: {
      crumbs: function() {
        return [{name:'Support'}, {name: this.$route.name}]
      },
      activeTab: function() {
        return this.$route.name;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Support.vue?74297343